<template>
  <div>
    <el-input
      :disabled="disabled"
      class="answer--text--input"
      autosize
      size="small"
      placeholder="请输入备注"
      v-model="answer.comment">
      <template slot="prepend">审核备注</template>
    </el-input>
  </div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  props: {
    answer: Object,
    disabled: Boolean,
  },
  data () {
    return {}
  },
  computed: {
    ...Vuex.mapState({}),
  },
  watch: {},
  beforeCreate () {},
  created () {
    this.$nextTick(() => {})
  },
  mounted () {
  },
  methods: {},
}
</script>
<style lang="scss">
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/packages/QuestionComment/index.vue